"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lissajous = void 0;
const math_1 = require("../../math");
const ShapeLoop_1 = require("../../shapes/ShapeLoop");
/**
 * Lissajous shape
 *
 * @category Shapes.ShapeLoop
 * @class Lissajous
 * @extends {ShapeLoop}
 */
class Lissajous extends ShapeLoop_1.ShapeLoop {
    /**
     * Creates an instance of Lissajous.
     *
     * @param {ILissajousSettings} [settings={}]
     * @memberof Lissajous
     */
    constructor(settings = {}) {
        settings.type = 'Lissajous';
        settings.loopDependencies = (settings.loopDependencies || []).concat(['wx', 'wy', 'wz']);
        super(settings, true);
        this.props.wx = settings.wx || 1;
        this.props.wy = settings.wy || 2;
        this.props.wz = settings.wz || 0;
        this.loop = {
            start: 0,
            end: math_1.PI2,
            inc: propArguments => {
                const wx = this.getProp('wx', propArguments);
                const wy = this.getProp('wy', propArguments);
                const ratio = wx == wy ? ShapeLoop_1.ShapeLoop.PId2 : 0.5 - Math.min(49, wx + wy) * 0.01;
                const sideLength = this.getRepetitionSideLength(propArguments);
                return (1 / Math.pow(sideLength[0] * sideLength[1], 0.25)) * ratio;
            },
            vertex: (shapeLoopRepetition) => {
                return this.wx === this.wy
                    ? [Math.cos(shapeLoopRepetition.current + this.wz), Math.sin(shapeLoopRepetition.current)]
                    : [Math.cos(this.wx * shapeLoopRepetition.current + this.wz), Math.sin(this.wy * shapeLoopRepetition.current)];
            },
        };
        this.bStaticLoop = this.isStaticLoop();
        this.bStatic = this.isStatic();
        this.bStaticIndexed = this.isStaticIndexed();
    }
    generateLoopBuffer(propArguments) {
        this.wx = this.getProp('wx', propArguments, 1);
        this.wy = this.getProp('wy', propArguments, 2);
        this.wz = this.getProp('wz', propArguments, 2);
        return super.generateLoopBuffer(propArguments);
    }
}
exports.Lissajous = Lissajous;
//# sourceMappingURL=Lissajous.js.map